import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import { LatLngExpression, Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React from 'react';

// Fix leaflet default marker icon issues in some bundlers (optional but common)
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { RouteResponse, Waypoint } from '../network/prompts_api';

// Set default marker icon
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

interface MainMapProps {
//   route?: [number, number][]; // [lng, lat]
  routeData?:RouteResponse
}

const defaultCenter: LatLngExpression = [51.752, -1.257];

const MainMap: React.FC<MainMapProps> = ({ routeData }) => {
  const leafletCoords: LatLngExpression[] | undefined = routeData?.route?.map(
    ([lng, lat]) => [lng, lat] // convert to [lat, lng] for Leaflet
  );

    const leafletWaypoints: Waypoint[] | undefined = routeData?.waypoints;

  return (
    <MapContainer center={defaultCenter} zoom={10} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="© OpenStreetMap contributors"
      />

      {leafletCoords && leafletCoords.length > 1 && (
        <Polyline
          positions={leafletCoords}
          pathOptions={{ color: 'blue', weight: 5 }}
        />
      )}

      {leafletWaypoints?.map((waypoint, index) => (
        <Marker key={index} position={waypoint.coordinates}>
          <Popup>{`${waypoint.name} (Stop ${index+1})`}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MainMap;
